import { createConsumer } from "@rails/actioncable";

const consumer = createConsumer();

export function subscribeToUserRole(onUpdate) {
  return consumer.subscriptions.create(
    { channel: "UserRoleChannel" },
    { received: onUpdate }
  );
}
